





























































































































































































































































import {Component, Vue, Watch, Provide} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import ClientComplaintState from '@/store/modules/clientComplaint/types';
import FilesUploader from '@/views/Client/Complaints/FilesUploader.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';

@Component({
    components: { FilesUploader, DatePicker },
})
export default class SingleComplaint extends Vue {

    @Action public updateClientComplaint: any;
    @Action public setSureModal: any;

    @State('clientComplaint') public clientComplaintState: ClientComplaintState;

    @Provide() public $bvModal: any;

    @Provide() public isDisabled = true;

    @Provide() public validation = {
        region: '', district: '', city: '', street: '', house: '', structure: '', building: '', description: '',
        installation_date: '', bad_date: '', conditions: '', wishes: '',
    };

    @Provide() public isChanged = false;

    @Provide() public lang = {
        formatLocale: {
            firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
    };

    @Watch('clientComplaintState.complaint', {immediate: true, deep: true})
    public async complaintWatch() {

        this.isChanged = true;

        this.validation = {
            region: '', district: '', city: '', street: '', house: '', structure: '', building: '', description: '',
            installation_date: '', bad_date: '', conditions: '', wishes: '',
        };
        this.isDisabled = false;


        if ((!this.clientComplaintState.complaint.region || this.clientComplaintState.complaint.region === '') &&
            (!this.clientComplaintState.complaint.district || this.clientComplaintState.complaint.district === '') &&
            (!this.clientComplaintState.complaint.city || this.clientComplaintState.complaint.city === '')) {
            if (!this.clientComplaintState.complaint.region || this.clientComplaintState.complaint.region === '') {
                this.validation.region = 'Необходимо указать республику, край, округ, область';
            }
            if (!this.clientComplaintState.complaint.district || this.clientComplaintState.complaint.district === '') {
                this.validation.district = 'Необходимо указать район';
            }
            if (!this.clientComplaintState.complaint.city || this.clientComplaintState.complaint.city === '') {
                this.validation.city = 'Необходимо указать город';
            }
            this.isDisabled = true;
        }

        // Если не указан номер дома или строение
        if ((!this.clientComplaintState.complaint.house || this.clientComplaintState.complaint.house === '')) {
            if (!this.clientComplaintState.complaint.house || this.clientComplaintState.complaint.house === '') {
                this.validation.house = 'Необходимо указать дом';
            }
            this.isDisabled = true;
        }

        // Длина полей
        if (this.clientComplaintState.complaint.region && this.clientComplaintState.complaint.region.length > 50) {
            this.validation.region = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.clientComplaintState.complaint.district && this.clientComplaintState.complaint.district.length > 50) {
            this.validation.district = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.clientComplaintState.complaint.city && this.clientComplaintState.complaint.city.length > 50) {
            this.validation.city = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }
        if (this.clientComplaintState.complaint.street && this.clientComplaintState.complaint.street.length > 50) {
            this.validation.street = 'Длина поля не должна превышать 50 символов';
            this.isDisabled = true;
        }

        if (this.clientComplaintState.complaint.house && this.clientComplaintState.complaint.house.length > 5) {
            this.validation.house = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }
        if (this.clientComplaintState.complaint.structure && this.clientComplaintState.complaint.structure.length > 5) {
            this.validation.structure = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }
        if (this.clientComplaintState.complaint.building && this.clientComplaintState.complaint.building.length > 5) {
            this.validation.building = 'Длина поля не должна превышать 5 символов';
            this.isDisabled = true;
        }

        if (!this.clientComplaintState.complaint.description || this.clientComplaintState.complaint.description === '') {
            this.validation.description = 'Необходимо указать причину обращения';
            this.isDisabled = true;
        }
        // Длина сообщения
        if (this.clientComplaintState.complaint.description && this.clientComplaintState.complaint.description.length > 250) {
            this.validation.description = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

        // Дата установки оборудования
        if (!this.clientComplaintState.complaint.installation_date || this.clientComplaintState.complaint.installation_date === '') {
            this.validation.installation_date = 'Необходимо указать дату установки оборудования';
            this.isDisabled = true;
        }

        // Дата возникновения неисправности
        if (!this.clientComplaintState.complaint.bad_date || this.clientComplaintState.complaint.bad_date === '') {
            this.validation.bad_date = 'Необходимо указать дату возникновения неисправности';
            this.isDisabled = true;
        }

        // Условия возникновения неисправности
        if (!this.clientComplaintState.complaint.conditions || this.clientComplaintState.complaint.conditions === '') {
            this.validation.conditions = 'Необходимо указать условия возникновения неисправности';
            this.isDisabled = true;
        }
        // Длина сообщения
        if (this.clientComplaintState.complaint.conditions && this.clientComplaintState.complaint.conditions.length > 250) {
            this.validation.conditions = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

        // Пожелания
        if (!this.clientComplaintState.complaint.wishes || this.clientComplaintState.complaint.wishes === '') {
            this.validation.wishes = 'Необходимо указать пожелания';
            this.isDisabled = true;
        }
        // Длина сообщения
        if (this.clientComplaintState.complaint.wishes && this.clientComplaintState.complaint.wishes.length > 250) {
            this.validation.wishes = 'Длина текста не должна превышать 250 символов';
            this.isDisabled = true;
        }

    }

    public update() {
        this.updateClientComplaint();
        this.close();
    }

    public send() {
        this.setSureModal({
            title: 'Отправить заявку на рассмотрение?',
            text: `Вы уверены, что хотите отправить заявку на рассмотрение? Редактировать заявку после отправки будет невозможно!`,
            buttonOk: 'Отправить заявку на рассмотрение',
            action: async () => {
                this.clientComplaintState.complaint.status = 'public';
                this.updateClientComplaint();
                this.close();
            },
        });
    }

    public close() {
        this.$bvModal.hide('singleClientComplaintModal');
    }

    /* Форматирование даты */

    private get resolvedInstallationDate() {
        return this.clientComplaintState.complaint.installation_date !== undefined ?
            new Date(this.clientComplaintState.complaint.installation_date) : new Date(Date.now());
    }

    private set resolvedInstallationDate(date) {
        this.clientComplaintState.complaint.installation_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

    private get resolvedBadDate() {
        return this.clientComplaintState.complaint.bad_date !== undefined ?
            new Date(this.clientComplaintState.complaint.bad_date) : new Date(Date.now());
    }

    private set resolvedBadDate(date) {
        this.clientComplaintState.complaint.bad_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    }

}
